(window.PAFloater = (function () {
  return {
    template: `
<style>
.PAFloater{
    width:90vw;
    margin:0 auto;
    padding:10px 5px;
    z-index:111;
background:{bgColor};
border: 1px solid {textColor}30;
border-radius: 10px;
}
.PAFloaterClose{
    position: absolute;
    right: 3vw;
    top: -1.5vw;
    border-radius: 50%;
padding: 0;
height: 5vw;
width: 5vw;
line-height: 1;
background: #999;
font-size: 1em;
color: #fff;
border-color: transparent !important;
box-shadow: none !important;
outline: none !important;
cursor:pointer;
}
.PAFloater img{
    width:15vh
    height:15vh;
    border-radius: 14px !important;
    max-width: 60px !important;
max-height: none !important;
margin-top: 10px;
}
.PAFloaterDetails{
    margin:5px;
}
    .PAFloaterTitle{
    text-transform:uppercase;
}
.PAFlexBox{
    display: flex;
    justify-content:space-around;
align-items:center;
}
h4.PAFloaterTitle {
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    color: #4e4b4b;
}

h5.PABigText {
    text-align: center;
    font-size: 11px;
    color: #000;
    font-weight: 200;
}

.PACTA{
    background-color: {ctaBgColor};
color: {ctaTextColor};
text-align: center;
text-decoration: none;
padding: 0.8em 1.2em;
border-radius: 10px;
}
.PAFloater p,h5,h4{
    margin:.25em 0;
}
.PAsub-desc{
    text-align: center;
    color: #000;
    font-weight: 200;
    font-size: 11px;
}
</style>
<div style="width:100vw;position:fixed;bottom: 10vh;z-index: 111;" id="PAFloaterContainer">
    <div class="PAFloater">
    <button class="PAFloaterClose" onclick="PAFloater.close()">X</button>
    <div class="PAFlexBox">
    <img src="{thumbnail}" alt="" />
    <div class="PAFloaterDetails">
    <h4 class="PAFloaterTitle">{title}</h4>
    <h5 class="PABigText">{subtitle}</h5>
    <p class="PAsub-desc">
    {description}
    </p>
    </div>
    <a id="pa-floater-cta" class="PACTA" href="{ctaLink}" target="_blank" onclick="PAFloater.ctaClick()">{ctaTitle}</a>
    </div>
    </div>
    </div>
`,
    settings: {
      theme: { bgColor: "#ffffff", textColor: "#000000" },
      title: "Download Our App!",
      subtitle: "Get 10% off on your first purchase!",
      description: "use code <b>APP10</b>",
      thumbnail:
        "https://d3myyafggcycom.cloudfront.net/LIVE/assets/ombre/62043632386b3.jpg",
      playstore:
        "https://play.google.com/store/apps/details?id=ombrelab.android.app",
      appstore: "https://apps.apple.com/us/app/ombre/id1621703581",
      cta: { title: "GET", bgColor: "#000000", textColor: "#ffffff" },
      display: {
        minVisitCount: 3,
        hideForDaysOnClose: 1,
        hideForDaysOnCtaClick: 7,
      },
    },
    init: function () {
      if (((this.settings.linkTo = this.getStore()), this.settings.linkTo)) {
        let t = parseInt(this.getCookie("PAFLoaterVisitCount")) || 0,
          e = parseInt(this.getCookie("PAFloaterKeepHidden")) || 0;
        if (((t += 1), t >= this.settings.display.minVisitCount && e == 0)) {
          let s = this.template
            .replace("{bgColor}", this.settings.theme.bgColor)
            .replace("{thumbnail}", this.settings.thumbnail)
            .replace("{textColor}", this.settings.theme.textColor)
            .replace("{title}", this.settings.title)
            .replace("{subtitle}", this.settings.subtitle)
            .replace("{description}", this.settings.description)
            .replace("{ctaTitle}", this.settings.cta.title)
            .replace("{ctaBgColor}", this.settings.cta.bgColor)
            .replace("{ctaTextColor}", this.settings.cta.textColor)
            .replace("{ctaLink}", this.settings[this.settings.linkTo]);
          document.body.insertAdjacentHTML("beforeend", s);
        }
        this.setCookie("PAFLoaterVisitCount", t, 365);
      }
    },
    setCookie: function (t, e, s) {
      let i = new Date();
      i.setTime(i.getTime() + s * 24 * 60 * 60 * 1e3);
      let r = "expires=" + i.toUTCString();
      document.cookie = t + "=" + e + ";" + r + ";";
    },
    getCookie: function (t) {
      for (
        var e = t + "=",
          s = decodeURIComponent(document.cookie),
          i = s.split(";"),
          r = 0;
        r < i.length;
        r++
      ) {
        for (var o = i[r]; o.charAt(0) == " "; ) o = o.substring(1);
        if (o.indexOf(e) == 0) return o.substring(e.length, o.length);
      }
      return !1;
    },
    getStore: function () {
      var t = navigator.userAgent || navigator.vendor || window.opera;
      return /windows phone/i.test(t)
        ? !1
        : /android/i.test(t)
        ? "playstore"
        : /iPad|iPhone|iPod/.test(t) && !window.MSStream
        ? "appstore"
        : !1;
    },
    close: function () {
      (document.getElementById("PAFloaterContainer").style.display = "none"),
        this.setCookie(
          "PAFloaterKeepHidden",
          1,
          this.settings.display.hideForDaysOnClose
        );
    },
    ctaClick: function () {
      this.setCookie(
        "PAFloaterKeepHidden",
        1,
        this.settings.display.hideForDaysOnCtaClick
      );
    },
  };
})()),
  PAFloater.init();
//# sourceMappingURL=/s/files/1/0619/4980/4766/files/pa-floater.js.map?v=1640190914
